import React from 'react';
import {
  Show,
  TabbedShowLayout,
  Tab,
  TextField,
  DateField,
  BooleanField,
  NumberField,
  ReferenceField,
  ReferenceManyField,
  Datagrid,
  ChipField,
  FunctionField,

} from 'react-admin';
import ReactMarkdown from 'react-markdown';

const challengeTypeChoices = [
  { id: 'QUIT_SMOKING', name: 'Бросить курить' },
  { id: 'QUIT_PORN', name: 'Бросить порно' },
  { id: 'QUIT_SUGAR', name: 'Бросить сахар' },
  { id: 'QUIT_ALCOHOL', name: 'Бросить алкоголь' },
  { id: 'EXERCISE', name: 'Упражнения' },
  { id: 'MEDITATION', name: 'Медитация' },
  { id: 'READING', name: 'Чтение' },
  { id: 'WATER_DRINKING', name: 'Пить воду' },
  { id: 'SLEEP_SCHEDULE', name: 'Режим сна' },
  { id: 'NO_SOCIAL_MEDIA', name: 'Без соцсетей' },
  { id: 'CUSTOM', name: 'Кастомный' },
];

const challengeStatusChoices = [
  { id: 'ACTIVE', name: 'Активный' },
  { id: 'PAUSED', name: 'Приостановлен' },
  { id: 'COMPLETED', name: 'Завершен' },
  { id: 'FAILED', name: 'Провален' },
];

const updateTypeChoices = [
  { id: 'CHECKIN', name: '✅ Чекин' },
  { id: 'START', name: '🚀 Старт' },
  { id: 'COMPLETION', name: '🎉 Завершение' },
  { id: 'FAILURE', name: '❌ Провал' },
  { id: 'STATUS_CHANGE', name: '🔄 Изменение статуса' },
  { id: 'MILESTONE', name: '🏆 Веха' },
  { id: 'MOTIVATION', name: '💪 Мотивация' },
  { id: 'STRUGGLE', name: '😰 Борьба' },
  { id: 'SUCCESS', name: '🎯 Успех' },
];

const TypeChip = ({ record }: any) => {
  if (!record || !record.type) return <span>-</span>;
  const typeChoice = challengeTypeChoices.find(choice => choice.id === record.type);
  return <ChipField record={{ value: typeChoice?.name || record.type }} source="value" />;
};

const StatusChip = ({ record }: any) => {
  if (!record || !record.status) return <span>-</span>;
  const statusChoice = challengeStatusChoices.find(choice => choice.id === record.status);
  return <ChipField record={{ value: statusChoice?.name || record.status }} source="value" />;
};

export const ChallengeShow = () => (
  <Show>
    <TabbedShowLayout>
      <Tab label="Основная информация">
        <TextField source="id" label="ID" />
        <TextField source="title" label="Название" />
        <TextField source="description" label="Описание" />
        <FunctionField 
          label="Тип"
          render={(record: any) => <TypeChip record={record} />}
        />
        <FunctionField 
          label="Статус"
          render={(record: any) => <StatusChip record={record} />}
        />
        <TextField source="mode" label="Режим" />
        
        <DateField source="startDate" label="Дата начала" showTime />
        <DateField source="endDate" label="Дата окончания" showTime />
        <DateField source="createdAt" label="Создан" showTime />
        <DateField source="updatedAt" label="Обновлен" showTime />
        
        <BooleanField source="isPublic" label="Публичный" />
        <NumberField source="maxParticipants" label="Максимум участников" />
      </Tab>

      <Tab label="Автор">
        <TextField source="user.name" label="Автор" />
        <TextField source="user.email" label="Email автора" />
        <TextField source="user.id" label="ID автора" />
      </Tab>

      <Tab label="Статистика">
        <NumberField source="currentStreak" label="Текущая серия" />
        <NumberField source="bestStreak" label="Лучшая серия" />
        <NumberField source="totalDays" label="Всего дней" />
        <NumberField source="daysActive" label="Активных дней" />
        <NumberField source="successRate" label="Процент успеха" />
        <NumberField source="participantsCount" label="Количество участников" />
        <NumberField source="pendingInvitationsCount" label="Ожидающие приглашения" />
      </Tab>

      <Tab label="Стейкинг">
        <BooleanField source="isStaked" label="Включен стейкинг" />
        <BooleanField source="stakingCompleted" label="Стейкинг завершен" />
        <TextField source="stakedAmount" label="Сумма стейка" />
        <TextField source="stakingTokenAddress" label="Адрес токена" />
        <TextField source="stakingTransactionHash" label="Хеш транзакции" />
      </Tab>

      <Tab label="Участники">
        <ReferenceManyField reference="challengeParticipants" target="challengeId" label="Участники">
          <Datagrid>
            <TextField source="id" label="ID" />
            <ReferenceField source="userId" reference="users" label="Пользователь">
              <TextField source="name" />
            </ReferenceField>
            <TextField source="role" label="Роль" />
            <TextField source="status" label="Статус" />
            <NumberField source="currentStreak" label="Текущая серия" />
            <NumberField source="bestStreak" label="Лучшая серия" />
            <NumberField source="successRate" label="% успеха" />
            <BooleanField source="isStaked" label="Стейкинг" />
            <DateField source="joinedAt" label="Присоединился" showTime />
          </Datagrid>
        </ReferenceManyField>
      </Tab>

      <Tab label="Приглашения">
        <ReferenceManyField reference="challengeInvitations" target="challengeId" label="Приглашения">
          <Datagrid>
            <TextField source="id" label="ID" />
            <ReferenceField source="inviterId" reference="users" label="Пригласил">
              <TextField source="name" />
            </ReferenceField>
            <ReferenceField source="inviteeId" reference="users" label="Приглашен">
              <TextField source="name" />
            </ReferenceField>
            <TextField source="status" label="Статус" />
            <TextField source="message" label="Сообщение" />
            <BooleanField source="isExpired" label="Истекло" />
            <DateField source="createdAt" label="Создано" showTime />
            <DateField source="expiresAt" label="Истекает" showTime />
            <DateField source="respondedAt" label="Ответ дан" showTime />
          </Datagrid>
        </ReferenceManyField>
      </Tab>

      <Tab label="События и чекины">
        <FunctionField 
          label="История событий"
          render={(record: any) => {
            if (!record.updates || record.updates.length === 0) {
              return <div style={{ padding: '16px', color: '#666' }}>Нет событий</div>;
            }
            
            return (
              <div style={{ padding: '16px' }}>
                <div style={{
                  marginBottom: '16px',
                  fontSize: '1.1em',
                  fontWeight: 'bold',
                  color: '#1a73e8'
                }}>
                  📋 События челленджа ({record.updates.length})
                </div>
                
                <div style={{ maxHeight: '700px', overflowY: 'auto' }}>
                  {[...record.updates]
                    .sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
                    .map((update: any) => {
                      const updateType = updateTypeChoices.find(choice => choice.id === update.type);
                      return (
                        <div 
                          key={update.id} 
                          style={{
                            border: '1px solid #e1e4e8',
                            borderRadius: '8px',
                            padding: '16px',
                            margin: '12px 0',
                            backgroundColor: '#f8f9fa',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            position: 'relative'
                          }}
                          onClick={() => {
                            // Переход к детальному просмотру события
                            window.open(`/challengeUpdates/${update.id}/show`, '_blank');
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#e8f0fe';
                            e.currentTarget.style.borderColor = '#1a73e8';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#f8f9fa';
                            e.currentTarget.style.borderColor = '#e1e4e8';
                          }}
                        >
                          {/* Заголовок события */}
                          <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center', 
                            marginBottom: '12px',
                            paddingBottom: '8px',
                            borderBottom: '1px solid #e9ecef'
                          }}>
                            <div style={{ 
                              fontSize: '16px', 
                              fontWeight: 'bold', 
                              color: '#1a73e8',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px'
                            }}>
                              {updateType?.name || update.type}
                              {update.dayNumber && (
                                <span style={{ 
                                  fontSize: '12px', 
                                  backgroundColor: '#1a73e8', 
                                  color: 'white', 
                                  padding: '2px 8px', 
                                  borderRadius: '12px' 
                                }}>
                                  День {update.dayNumber}
                                </span>
                              )}
                            </div>
                            <div style={{ fontSize: '12px', color: '#666' }}>
                              📅 {new Date(update.createdAt).toLocaleString('ru-RU')}
                            </div>
                          </div>
                          
                          {/* Автор */}
                          <div style={{ 
                            fontSize: '13px', 
                            color: '#1a73e8', 
                            marginBottom: '12px',
                            fontWeight: '500'
                          }}>
                            👤 {update.user?.name || update.user?.email || 'Неизвестный автор'}
                          </div>
                          
                          {/* Содержимое с Markdown */}
                          {update.content && (
                            <div style={{
                              fontSize: '14px',
                              marginBottom: '12px',
                              lineHeight: '1.5',
                              maxHeight: '150px',
                              overflow: 'hidden',
                              position: 'relative'
                            }}>
                              <ReactMarkdown
                                components={{
                                  code: ({ node, inline, children, ...props }: any) => {
                                    if (inline) {
                                      return (
                                        <code
                                          style={{
                                            backgroundColor: '#f1f3f4',
                                            padding: '1px 4px',
                                            borderRadius: '3px',
                                            fontSize: '0.9em',
                                            fontFamily: 'monospace'
                                          }}
                                          {...props}
                                        >
                                          {children}
                                        </code>
                                      );
                                    }
                                    return (
                                      <code
                                        style={{
                                          backgroundColor: '#f8f8f8',
                                          padding: '2px 4px',
                                          borderRadius: '3px',
                                          fontSize: '0.9em',
                                          fontFamily: 'monospace',
                                          display: 'inline-block'
                                        }}
                                        {...props}
                                      >
                                        {children}
                                      </code>
                                    );
                                  },
                                  h1: ({ children }) => <strong>{children}</strong>,
                                  h2: ({ children }) => <strong>{children}</strong>,
                                  h3: ({ children }) => <strong>{children}</strong>,
                                  p: ({ children }) => <span>{children} </span>,
                                  a: ({ children }) => <span style={{ color: '#1a73e8' }}>{children}</span>,
                                }}
                              >
                                {update.content.length > 200 
                                  ? update.content.substring(0, 200) + '...'
                                  : update.content
                                }
                              </ReactMarkdown>
                              
                              {update.content.length > 200 && (
                                <div style={{
                                  position: 'absolute',
                                  bottom: '0',
                                  right: '0',
                                  background: 'linear-gradient(to right, transparent, #f8f9fa)',
                                  padding: '0 8px',
                                  fontSize: '12px',
                                  color: '#1a73e8',
                                  fontStyle: 'italic'
                                }}>
                                  нажмите для подробностей...
                                </div>
                              )}
                            </div>
                          )}
                          
                          {/* Изображения */}
                          {update.images && update.images.length > 0 && (
                            <div style={{ 
                              fontSize: '12px', 
                              color: '#666', 
                              marginBottom: '8px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px'
                            }}>
                              📷 {update.images.length} изображений
                            </div>
                          )}
                          
                          {/* Статистика */}
                          <div style={{ 
                            display: 'flex', 
                            gap: '16px', 
                            fontSize: '12px', 
                            color: '#666',
                            alignItems: 'center'
                          }}>
                            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                              ❤️ {update.likesCount || 0}
                            </span>
                            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                              💬 {update.commentsCount || 0}
                            </span>
                            <span style={{
                              marginLeft: 'auto',
                              color: '#1a73e8',
                              fontSize: '11px',
                              fontWeight: '500'
                            }}>
                              🔗 Кликните для деталей
                            </span>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            );
          }}
        />
      </Tab>
    </TabbedShowLayout>
  </Show>
);
